import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import Autosuggest from 'react-autosuggest';
import cross from './cross.svg';
import './auto-suggest-input.scss';

class AutoSuggestInput extends Component {
  constructor() {
    super();
    this.state = {
      entityValue: '',
      suggestions: [],
    }
    this.teamInputRef = React.createRef();
  }

  updateValue = (event, { newValue }) => {
    this.setState({
      entityValue: newValue
    });
  }

  addEntity = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (!this.state.entityValue) {
      toast.error('Нельзя добавить пустое значение');
      return;
    }
    const res = this.props.addEntity(this.state.entityValue);
    if (!res || !res.then) {
      this.resetForm();
      return;
    }
    res.then(this.resetForm).catch((errorText) => toast.error(errorText));
  }

  resetForm = () => {
    this.setState({
      entityValue: '',
      suggestions: [],
    })
  }

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  getSuggestions = (value) => {
    if (this.props.getSuggestions) {
      return this.props.getSuggestions(value);
    }
    return [];
  }

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  };

  renderSuggestion = suggestion => (
    <div className="suggestion-row">
      {suggestion}
    </div>
  );

  getSuggestionValue = suggestion => suggestion;

  onKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.addEntity();
    }
  }

  render() {
    const { entityValue, suggestions } = this.state;
    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: '',
      value: entityValue,
      onChange: this.updateValue,
      onKeyPress: this.onKeyPress,
    };

    return (
      <div className='auto-suggest'>
        <div className='auto-suggest--add' onClick={this.addEntity} >
          <img src={cross} alt="cross"/>
        </div>
        <div className="auto-suggest--input">
          <Autosuggest
            suggestions={suggestions}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}
            inputProps={inputProps} />
        </div>
      </div>
    );
  }
}

AutoSuggestInput.propTypes = {
  addEntity: PropTypes.func.isRequired,
  getSuggestions: PropTypes.func,
}

export default AutoSuggestInput;



// WEBPACK FOOTER //
// ./src/components/Common/AutoSuggestInput/index.js